import React from 'react';
export function Footer() {
  return <footer className="w-full bg-white border-t border-brown/10 py-8 px-4" data-id="element-81">
      <div className="max-w-4xl mx-auto text-center" data-id="element-82">
        <p className="font-serif text-xs md:text-sm text-gray-400 leading-relaxed max-w-2xl mx-auto" data-id="element-83">
          Dies ist ein persönlicher Erfahrungsbericht. Ergebnisse können
          individuell variieren. Bei anhaltenden Beschwerden bitte einen
          Tierarzt aufsuchen.
        </p>
        <div className="mt-6 font-handwriting text-xl text-brown/40" data-id="element-84">
          Napftagebuch © {new Date().getFullYear()}
        </div>
      </div>
    </footer>;
}